'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dGroup$002dRestrictions$002dView$0024$0024anon$002451 from "./presto.-Group-Restrictions-View$$anon$51.js";
import * as $j_presto$002etypes$0024$002dAccount$002dId$0024 from "./presto.types$-Account-Id$.js";
import * as $j_presto$002etypes$0024$002dGrouping$0024 from "./presto.types$-Grouping$.js";
import * as $j_presto$002etypes$0024$002dGrouping$002dDescription$0024 from "./presto.types$-Grouping-Description$.js";
import * as $j_presto$002etypes$0024$002dGrouping$002dId$0024 from "./presto.types$-Grouping-Id$.js";
import * as $j_presto$002etypes$0024$002dGrouping$002dKind$0024 from "./presto.types$-Grouping-Kind$.js";
import * as $j_presto$002etypes$0024$002dGrouping$002dName$0024 from "./presto.types$-Grouping-Name$.js";
var $p;
/** @constructor */
function $c_Lpresto_GroupRestrictionsView$$anon$50() {
  this.aTX = null;
  this.aTP = null;
  this.aTQ = false;
  this.aTY = null;
  this.aTZ = false;
  this.aU2 = null;
  this.aTV = null;
  this.aTW = false;
  this.aTR = null;
  this.aTS = false;
  this.aTT = null;
  this.aTU = false;
  this.aU0 = false;
  this.aU1 = false;
  this.aTX = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.aU2 = "Grouping";
}
export { $c_Lpresto_GroupRestrictionsView$$anon$50 as $c_Lpresto_GroupRestrictionsView$$anon$50 };
$p = $c_Lpresto_GroupRestrictionsView$$anon$50.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_GroupRestrictionsView$$anon$50;
/** @constructor */
function $h_Lpresto_GroupRestrictionsView$$anon$50() {
}
export { $h_Lpresto_GroupRestrictionsView$$anon$50 as $h_Lpresto_GroupRestrictionsView$$anon$50 };
$h_Lpresto_GroupRestrictionsView$$anon$50.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.J = (function() {
  return this.aTX;
});
$p.L = (function() {
  if ((!this.aTQ)) {
    this.aTP = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.aTQ = true;
  }
  return this.aTP;
});
$p.O = (function() {
  if ((!this.aTZ)) {
    this.aTY = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.aTZ = true;
  }
  return this.aTY;
});
$p.E = (function() {
  return this.aU2;
});
$p.t = (function() {
  if ((!this.aTW)) {
    this.aTV = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("id", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("created", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("account", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("kind", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("name", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("description", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))))));
    this.aTW = true;
  }
  return this.aTV;
});
$p.M = (function() {
  if ((!this.aTS)) {
    this.aTR = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dGrouping$002dId$0024.$m_Lpresto_types$GroupingId$().nJ(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().Z(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dAccount$002dId$0024.$m_Lpresto_types$AccountId$().bl(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder($j_presto$002etypes$0024$002dGrouping$002dKind$0024.$m_Lpresto_types$GroupingKind$().p4())), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dGrouping$002dName$0024.$m_Lpresto_types$GroupingName$().nK(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dGrouping$002dDescription$0024.$m_Lpresto_types$GroupingDescription$().p3(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))))));
    this.aTS = true;
  }
  return this.aTR;
});
$p.Q = (function() {
  if ((!this.aTU)) {
    this.aTT = new $j_presto$002e$002dGroup$002dRestrictions$002dView$0024$0024anon$002451.$c_Lpresto_GroupRestrictionsView$$anon$51();
    this.aTU = true;
  }
  return this.aTT;
});
$p.w = (function() {
  if ((!this.aU1)) {
    this.aU0 = false;
    this.aU1 = true;
  }
  return this.aU0;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee333) => ((p) => \u03b4scrutinee333.p0(p)))($j_presto$002etypes$0024$002dGrouping$0024.$m_Lpresto_types$Grouping$())));
});
var $d_Lpresto_GroupRestrictionsView$$anon$50 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_GroupRestrictionsView$$anon$50, "presto.GroupRestrictionsView$$anon$50", ({
  IW: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_GroupRestrictionsView$$anon$50 as $d_Lpresto_GroupRestrictionsView$$anon$50 };
//# sourceMappingURL=presto.-Group-Restrictions-View$$anon$50.js.map
